import { useList } from '@refinedev/core';
import type { PublicationListOut } from '@/api/generated/schemas';

/**
 * The publication behind a product id, for records that only carry
 * `product_id`. The endpoint filters on `product_ids[in]`, so a single id
 * goes in as a one-element list.
 *
 * Everything that needs the publication for one product goes through this
 * hook, so the query key stays identical and the title link and the format
 * tag on the same page share one request.
 */
export const usePublicationByProduct = (productId: number) => {
  const { result } = useList<PublicationListOut>({
    resource: 'user_catalog.publications',
    filters: [{ field: 'product_ids', operator: 'in', value: [productId] }],
    pagination: { pageSize: 1, mode: 'server' },
  });

  return result?.data?.[0];
};
